<script lang="ts" setup>
import type { TFeedbackQuestionOption } from '../types';

type Props = {
  item: TFeedbackQuestionOption;
  active: boolean;
};

const { active, item } = defineProps<Props>();
const emit = defineEmits(['clickStar']);
const click = () => {
  emit('clickStar', item);
};
</script>

<template>
  <div class="feedback-item flex cursor-pointer flex-col items-center" @click="click">
    <div
      class="emoji !mb-1 flex !h-[40px] !w-[40px] items-center justify-center rounded-[2rem] border border-solid border-light-100"
      :class="{ 'border-blue-325': active }">
      <img alt="" :src="item.icon" class="!h-[30px] !w-[30px]" />
    </div>
    <span
      :class="{ 'text-blue-300': active }"
      class="feedback-item-text text-center text-xs font-normal text-light-mode-low-contrast">
      {{ item.label }}
    </span>
  </div>
</template>
<style scoped lang="scss">
.feedback-item {
  // flex: 1;
  // width: 46px;
  padding-bottom: 4px;
  padding-top: 4px;
  .feedback-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    line-clamp: 1;
    -webkit-box-orient: vertical;
    // max-width: calc(100% - 6px);
  }
  &:hover {
    .emoji {
      @apply border-blue-325;
    }
    .feedback-item-text {
      @apply text-blue-300;
    }
  }
}
</style>
